<template>
  <div>
    <div v-if="show">
      <b-col md="12">
        <b-spinner
          variant="secondary"
          class="mr-1"
        />
        <span class="text-secondary">Consultando Balance...</span>
      </b-col>
    </div>
    <div v-else>
      <b-col md="12">
        <b-form-input
          v-model="amount"
          size="lg"
          :disabled="disabled"
        />
      </b-col>
      <b-col
        md="12"
        class="mt-1"
      >
        <b-button
          variant="primary"
          block
          size="lg"
          :disabled="disabled"
          @click="loadFormPayPal()"
        >
          Confirmar Valor de Pago
        </b-button>
      </b-col>
      <b-col
        md="12"
        class="mt-5"
      >
        <b-form align="center">
          <div id="paypal-button-container" />
        </b-form>
      </b-col>
    </div>
  </div>
</template>

<script>
import { BButton, BCol, BForm, BFormInput, BSpinner } from 'bootstrap-vue'

export default {
    components: {
        BCol,
        BSpinner,
        BForm,
        BFormInput,
        BButton,
    },
    props: {
        idcontrato: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            keyPayPal: null,
            amount: 0,
            disabled: false,
        }
    },
    created() {
        this.searchBalance()
        this.loadPayPal()
    },
    methods: {
        searchBalance() {
            this.show = true
            this.$http
                .get('/contrato-balance/', {
                    params: {
                        idcontrato: this.idcontrato,
                        opresumen: 1,
                    },
                })
                .then((response) => {
                    this.show = false
                    if (response.data) {
                        this.amount = response.data.data
                    }
                })
                .catch(() => {
                    this.show = false
                })
        },
        loadPayPal() {
            this.$http
                .get('/paypal/', {
                    params: {
                        estado: 'A',
                    },
                })
                .then((response) => {
                    this.keyPayPal = response.data.data.key_private
                    this.loadJsPayPal()
                })
                .catch(() => {})
        },
        loadJsPayPal() {
            const paypal = document.createElement('script')
            paypal.setAttribute(
                'src',
                `https://www.paypal.com/sdk/js?client-id=${  this.keyPayPal}`
            )
            document.head.appendChild(paypal)
        },
        loadFormPayPal() {
            this.disabled = true
            const amount = String(this.amount)
            const self = this
            window.paypal
                .Buttons({
                    createOrder(data, actions) {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: amount,
                                    },
                                },
                            ],
                        })
                    },
                    onApprove(data, actions) {
                        return actions.order.capture().then((details) => {
                            self.$http
                                .post('/paypal/', {
                                    id: details.id,
                                    status: details.status,
                                    res: details,
                                    idcontrato: self.idcontrato,
                                })
                                .then((response) => {
                                    const {msn} = response.data

                                    if (msn === 'COMPLETED') {
                                        self.$router.push({
                                            name: 'pago-resumen',
                                        })
                                    } else {
                                        self.$router.push({
                                            name: 'pago-error',
                                        })
                                    }
                                })
                                .catch(() => {})
                        })
                    },
                    onError() {
                        self.$router.push({ name: 'pago-error' })
                        self.disabled = false
                    },
                })
                .render('#paypal-button-container')
        },
    },
}
</script>
